import { WATERCRAFT_ROUTE } from '../../app/appConstants';

/**
 * Sub-routes of the watercraft flow, kept scoped to the watercraft router rather
 * than the global appConstants. The entry point (WATERCRAFT_ROUTE) stays global
 * since it's referenced from outside this flow; everything else derives from it.
 */
export const WATERCRAFT_LOGIN_ROUTE = `${WATERCRAFT_ROUTE}/login`;
export const WATERCRAFT_ACCOUNT_CREATION_ROUTE = `${WATERCRAFT_ROUTE}/create-account`;
export const WATERCRAFT_SUCCESS_ROUTE = `${WATERCRAFT_ROUTE}/success`;
export const WATERCRAFT_MANAGE_ROUTE = `${WATERCRAFT_ROUTE}/manage`;
export const WATERCRAFT_PASSES_ROUTE = `${WATERCRAFT_ROUTE}/passes`;
export const WATERCRAFT_PASSES_SUCCESS_ROUTE = `${WATERCRAFT_ROUTE}/passes/success`;
